<template>
	<div class="handleworklist">
		<el-card>
			<el-tabs v-model="activetab" @tab-click="GetTabData">
				<el-tab-pane :label="tab.name" :name="tab.name" v-for="tab in tabs" :key="tab.l_id">
					<span slot="label">{{ tab.name }} ({{ tab.count }})</span>
					<el-row>
						<el-col :span="17">
							<handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton>
							<span style="color:transparent" v-if="tab.buttons.length < 1">占位</span>
						</el-col>
						<el-col :span="1" class="rightcol"><el-button icon="el-icon-refresh-right" circle size="mini" @click.native="ResetFilterInfo()"></el-button></el-col>
						<el-col :span="4"><el-input placeholder="搜索" v-model="searchbox" size="small" @keyup.enter.native="refreshgrid(true)"></el-input></el-col>
						<el-col :span="2" class="rightcol">
							<el-popover placement="bottom-end" :width="filterlist.length > 0 ? 500 : 340" trigger="click">
								<table class="htmltable">
									<tr>
										<td><label>问题类型</label></td>
										<td>
											<el-select size="mini" v-model="searchlist.q_type">
												<el-option v-for="item in q_typelist" :key="item.d_name" :label="item.d_name" :value="item.d_name"></el-option>
											</el-select>
										</td>
										<td rowspan="3" valign="top" class="filter" v-if="filterlist.length > 0">
											<div>常用筛选</div>
											<ul>
												<li v-for="(item, index) in filterlist">
													<el-radio v-model="searchlist.fixfilter" :label="item.fname" @change="Setfilterchecked">{{ item.fname }}</el-radio>
												</li>
											</ul>
										</td>
									</tr>
									<tr>
										<td><label>服务单级别</label></td>
										<td style="text-align:left;">
											<el-select size="mini" v-model="searchlist.q_level">
												<el-option v-for="item in q_levellist" :key="item.d_name" :label="item.d_name" :value="item.d_name"></el-option>
											</el-select>
										</td>
									</tr>
									<tr>
										<td><label>提交时间</label></td>
										<td style="text-align:left;">
											<el-date-picker
												v-model="searchlist.starttime"
												type="date"
												placeholder="选择开始日期"
												size="mini"
												value-format="yyyy-MM-dd"
											></el-date-picker>
										</td>
									</tr>
									<tr>
										<td><label>至</label></td>
										<td>
											<el-date-picker
												v-model="searchlist.endtime"
												type="date"
												placeholder="选择结束日期"
												size="mini"
												value-format="yyyy-MM-dd"
											></el-date-picker>
										</td>
									</tr>
									<tr>
										<td colspan="4" class="bottombtn">
											<el-button @click="GetTabData()" type="warning" size="mini">查询</el-button>
											<el-button @click="ClearSearch(0)" size="mini">清空</el-button>
										</td>
									</tr>
								</table>

								<el-link slot="reference" type="primary">更多筛选</el-link>
							</el-popover>
						</el-col>
					</el-row>
					<el-row style="height:10px;"></el-row>
					<el-row>
						<el-col :span="24">
							<tableui
								style="width:100%;"
								v-loading="loading"
								ref="handleworklist"
								:tableData="handleworklist"
								:columns="tab.columns"
								@gridhandle="gridhandle"
								:gridheight="gridheight"
								@gridsort="gridsort"
								@checkboxchange="checkboxchange"
								@gridscroll="gridscroll"
								:istop="istop"
							></tableui>
						</el-col>
					</el-row>
				</el-tab-pane>
			</el-tabs>
		</el-card>
	</div>
</template>
<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableui from '@/components/table/tablegrid.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui,
		handlerbutton
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			istop: false,
			searchlist: {
				starttime: '',
				endtime: '',
				q_type: '', //问题类型
				q_level:'',
				fixfilter: '',
				fixsort: ''
			},
			searchbox: '',
			activetab: '',
			activeName: '',
			activeTabIndex: 0, //激活的选项卡index
			type: '',
			pickerOptions: '',
			handleworklist: [],
			gridheight: (window.innerHeight * 66) / 100 + 'px',
			loading: false,
			pageindex: 0,
			pagesize: 200,
			search: '',
			sort: '',
			tabs: [],
			mode: '处理服务单', //当前操作的功能模块名称
			filterlist: [], //常用筛选条件
			selectedall: false,
			checkedrow: [],
			batch: '',
			divclass: 'handleworklist',
			q_typelist: [],
			q_levellist:[]
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/workorders/handleworklist.scss');
			this.getTabs();
		});
		var that = this;
		Utils.$on('refreshgrid', function(msg) {
			that.refreshgrid(true);
		});
		this.Getqtype();
		this.GetLevel();
	},
	methods: {
		//获取选项卡
		getTabs() {
			this.$apipost.get.GetTabs({ parentid: 155 }).then(res => {
				this.tabs = res.tabs;
				this.activeName = this.tabs[this.activeTabIndex].type;
				this.activetab = this.tabs[this.activeTabIndex].name;

				this.GetTabData();
			});
		},
		//获取问题类型
		async Getqtype() {
			var that = this;
			this.$apipost.get.dic({ type: '问题类型' }).then(res => {
				if (res != '') {
					that.q_typelist = res.data.list;
				}
			});
		},
		async GetLevel() {
			var that = this;
			this.$apipost.get.dic({ type: '问题优先级' }).then(res => {
				if (res != '') {
					that.q_levellist = res.data.list;
				}
			});
		},
		//清空筛选条件
		ClearSearch(type) {
			this.searchlist = {
				starttime: '',
				endtime: '',
				q_type: '',
				q_level:'',
				fixfilter: ''
			};
			if (type == 1) {
				this.searchbox = '';
			}
		},
		//滚动加载列表
		gridscroll(e) {
			if (e != undefined) {
				var that = this;
				const scrollDistance = e.event.target.scrollHeight - e.e.scrollTop - e.event.target.offsetHeight;
				if (scrollDistance <= 84) {
					that.refreshgrid(false);
				}
			}
		},
		//获取表头方法
		GetTabData(tab) {
			if (tab != undefined) {
				this.activeTabIndex = tab.index;
				this.activeName = this.tabs[this.activeTabIndex].type;
				this.activetab = this.tabs[this.activeTabIndex].name;
			}
			this.GetFilter(); //加载选项卡对应的筛选条件
			this.GetMyWorkCount(); //获取汇总数
			if (this.tabs[this.activeTabIndex].columns.length == 0) {
				this.GetColumns();
			} else {
				this.refreshgrid(true);
			}
		},
		//刷新列表
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			this.istop = false;
			if (isrefresh) {
				this.handleworklist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.istop = true;
				this.selectedall=false;
			} else {
				//加载下一页
				if (parseInt(this.tabs[this.activeTabIndex].pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				this.loading = true;
				var paraminfo = {
					search: this.GetSearchObj(),
					pageindex: this.pageindex,
					pagesize: this.pagesize,
					sort: this.sort,
					tab:this.activeName,
					l_mode:this.mode,
					showcol: JSON.stringify(this.tabs[this.activeTabIndex].columns),
					userid: localStorage.getItem('userid')
				};
				this.$apipost.get.GetMyWorkList({ paraminfo: paraminfo }).then(res => {
					that.loading = false;
					if (res.data.length > 0) {
						if (that.pageindex > 0) {
							that.handleworklist = that.handleworklist.concat(res.data);
						} else {
							that.handleworklist = res.data;
						}
					}
				});
				this.GetMyWorkCount(); //获取汇总数
			}
		},
		//组合筛选条件
		GetSearchObj() {
			var search = JSON.parse(JSON.stringify(this.searchlist));
			if (search.fixfilter != '') {
				var that = this;
				var searchtype = '';
				this.filterlist.forEach(e => {
					if (e.fname == search.fixfilter) {
						if (e.handlertype == 'filter') {
							searchtype = e.searchtype;
							return false;
						} else if (e.handlertype == 'sort') {
							searchtype = '';
							search.fixfilter = '';
							search.fixsort = e.filter;
							return false;
						}
					}
				});
				search.searchtype = searchtype;
			}
			if (this.searchbox != '') {
				search.searchbox = this.searchbox;
			}
			return JSON.stringify(search);
		},
		//获取列配置信息
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 1, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode }).then(res => {
				that.tabs[that.activeTabIndex].columns = res;
				that.refreshgrid(true);
			});
		},
		//获取客服管理
		GetMyWorkCount() {
			var that = this;
			this.$apipost.get.GetMyWorkCount({ l_mode: this.mode, search: this.GetSearchObj() }).then(res => {
				if (res.state == '1') {
					for (var i = 0; i < that.tabs.length; i++) {
						var countlist = res.countlist[0];
						for (var e in countlist) {
							if (e == that.tabs[i].type) {
								that.tabs[i].count = countlist[e];
								break;
							}
						}
					}
					that.setpagecount();
				}
			});
		},
		//设置分页显示数
		setpagecount() {
			var tabs = this.tabs;
			tabs.forEach(e => {
				if (parseInt(e.count) % this.pagesize == 0) {
					e.pagecount = parseInt(e.count) / this.pagesize;
				} else {
					e.pagecount = parseInt(parseInt(e.count) / this.pagesize) + 1;
				}
			});
		},
		//列表排序
		gridsort(e) {
			//e.column.prop--排序列名
			//e.column.order--ascending/descending --排序方式
			console.log('排序', e);
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			this.refreshgrid(true);
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			if (e.event == 'end') {
				this.endOrder();
			}
			if(e.event=='addworks'){
				Utils.$emit('go', { l_url: '/workorders/workcontext', l_id: e.l_id, l_name:e.l_name, urlparam: {} });
			}
		},
		//列表中的自定义列的操作事件
		gridhandle(e) {
			this.checkedrow = [];
			if (e.event == 'end') {
				this.checkedrow.push(this.handleworklist[e.index]);
				this.endOrder();
			}
			if (e.event == 'handle') {
				Utils.$emit('go', { l_url: '/workorders/handlework', l_id: e.l_id, l_name: '处理服务', urlparam: { q_id: this.handleworklist[e.index].q_id } });
			}
			if (e.event == 'showdetail') {
				Utils.$emit('go', { l_url: '/workorders/handlework', l_id: e.l_id, l_name: '服务单详情', urlparam: { q_id: this.handleworklist[e.index].q_id,showdetail:true } });
			}
		},
		//获取常用筛选条件
		GetFilter() {
			var that = this;
			this.$apipost.get.GetFilter({ l_mode: this.mode, type: this.tabs[this.activeTabIndex].type }).then(res => {
				if (res != '') {
					that.filterlist = res.data;
				}
			});
		},
		//设置常用筛选
		Setfilterchecked(value) {
			this.searchlist.fixfilter = value;
		},
		//复选框勾选触发
		checkboxchange(e) {
			this.checkedrow = e.rows; //勾选了的列表
			this.selectedall = e.selectedall;
		},
		//结束服务单
		endOrder() {
			if(this.checkedrow.length==1){
				var that = this;
				this.$confirm('确定要结束此服务单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
					.then(() => {
						var paraminfo={
							isend:1,
							form:{
								q_id:that.checkedrow[0].q_id,
								p_pkval:that.checkedrow[0].p_pkval
							},
							u_userid:localStorage.getItem('userid'),
							u_account:localStorage.getItem('u_account')
						}
						this.$tool.loading('正在结束服务单',this.divclass);
						this.$apipost.post.SaveWorkContext({ paraminfo:paraminfo}).then(res => {
							this.$tool.loadingclose();
							if (res != '') {
								if(res.state=='1')
								{
									this.$tool.message('操作成功', 1);
									that.refreshgrid(true);
								}
								else {
									this.$tool.message('操作失败', 0);
								}
							} 
						});
					})
					.catch(() => {});
			}else{
				this.$tool.message('请选择一条记录操作', 0);
			}	
		},
		//重置筛选
		ResetFilterInfo() {
			this.ClearSearch(1); //先清空筛选条件
			this.refreshgrid(true);
		},
		//获取勾选数据组合json
		GetCheckedOrder(isempty) {
			var pkval = '';
			var isgo = true;
			var search = {
				q_id: ''
			};
			var searchinfo = '';
			if (!this.selectedall) {
				this.checkedrow.forEach(e => {
					q_id += e.q_id + ',';
				});
				if (q_id != '') {
					q_id = q_id.substring(0, pkval.length - 1);
					search.q_id = q_id; //这里的筛选条件对象的结构与订单筛选条件结构一致
					searchinfo = JSON.stringify(search);
				} else {
					if (!isempty) this.$tool.message('请勾选数据', 2);
				}
			} else {
				searchinfo = this.GetSearchObj();
			}
			return searchinfo;
		}
	}
};
</script>
